export const LEGACY_NON_TEAM_PATHS = [
	'/catalog',
	'/metrics',
	'/collections',
	'/docs',
	'/questions',
	'/dictionary',
	'/glossary',
	'/bi/dashboards',
] as const;
